<template>
    <transition-group
        name="list"
        tag="ul"
        class="l-ss-c-completions-tags-group">
        <li
            v-for="(tag, index) in sortedTags"
            :key="`tag-${index}`"
            class="l-ss-c-completions-tags"
            @click="handleTagsClick($event, tag, index)"
            v-html="tag.label">
        </li>
    </transition-group>
</template>
<script>
    export default {
        props: {
            data: {
                type: Array,
                default: () => ([]),
            },
            isTapsComplitions: {
                type: Boolean,
                default: false,
            },
            query: {
                type: String,
                default: '',
            },
            count: {
                type: Number,
            },
        },
        computed: {
            sliceTags() {
                return this.data.slice(0, this.count);
            },
            sortedTags() {
                const tags = [...this.sliceTags];

                return tags.sort((a, b) => b.label.length - a.label.length);
            },
        },
        methods: {
            handleTagsClick(event, tag, index) {
                const query = tag.query;

                const formatTags = this.sortedTags.map(tag => tag.query);

                const trackParams = {
                    pos: index + 1,
                    selectTag: tag.query,
                    tags: formatTags,
                    event,
                };

                this.$emit('handle-tags-click', query);

                if (!this.isTapsComplitions) {
                    this.$emit('result-tab-click', {
                        type: 'resultTabClick',
                        ...trackParams,
                    });
                } else {
                    this.$emit('preview-tab-click', {
                        type: 'previewTabClick',
                        ...trackParams,
                    });
                }
            },
        },
    };
</script>
